module.exports = __webpack_public_path__ + "static/media/jackpot-inner-background.3ab6d8f1.jpg";